/* eslint-disable indent */
/* eslint-disable no-mixed-spaces-and-tabs */
/**
 * TopSection.js
 * Created by calhosh on 2/26/2021.
 */

import React, {useEffect, useState} from 'react';
import {actionIcPrint24px, actionIcUpdate24px} from '@ey/motif-react-wrapper/assets/icons/index';
import {
	IconoirCustomMoreVerticalAlt,
	IconoirRefreshDouble,
	IconoirPrintingPage,
	IconoirNavArrowRight,
	IconoirNavArrowLeft
} from '@ey-xd/motif-icon';
import {SVGICONS} from '@ey/icons';
import env from '../../../util/env';
import {documentTypes, entities, validationFilter, validationTypes, ViewModes} from '../../../util/uiconstants';
import {currentResource, labels} from '../../../util/utils';
import ValidationControl from '../CanvasForm/Common/ValidationControl';
import EllipsesMoment from '../../Common/EllipsesControl/EllipseMoment';
import EllipseControl from '../../Common/EllipsesControl/EllipsesControl';
import {loadStorage} from '../localStorage';
import NotesCount from '../../Common/ReviewNotes/NotesCount';
import ReactSelect from '../../Common/SelectDropdown/SelectDropdown';
import SignOffs from '../../Common/SignOffs/SignOffs';
import Search from '../../Common/BaseComponentWrappers/MotifSearch';
import Dropdown from '../../Common/BaseComponentWrappers/MotifDropdown';
import DropdownItem from '../../Common/BaseComponentWrappers/MotifDropdownItem';
import Icon from '../../Common/BaseComponentWrappers/MotifIcon';
import IconButton from '../../Common/BaseComponentWrappers/MotifIconButton';
import CanvasFormViewType from './CanvasFormViewType';
import {useIsDrawerMode} from '../../../util/Ares/customHooks';
import {theme} from 'highcharts';
import {getTheme} from '@ey/styled-theme';
import styled from 'styled-components';

export default function TopSection(props) {
	const {
		userPreferences,
		engagement,
		hasContentUpdate,
		documentTypeId,
		independenceInfo,
		formName,
		onExpandCollapseClick,
		isExpanded,
		setStatusLabel,
		filteredMoreMenuItems,
		setIsExpanded,
		onSearchChange,
		searchValue,
		page,
		setPage,
		validationFilterOption,
		validationFilterChange,
		onFormViewLabelClick,
		incompleteValidations,
		unresolvedValidations,
		validations,
		clearComments,
		setDocument,
		onSignOffAdded,
		onSignOffRemoved,
		document,
		showDocName,
		signOffs,
		accountName,
		itFlowValidationCount,
		itFlowFormValidations,
		documentId,
		showChangesOption
	} = props;

	const [isOpenMoreMenu, setIsOpenMoreMenu] = useState(false),
		[inconsistentFormsCount, setInconsistentFormsCount] = useState(0);

	let viewTypeOptions = Object.values(ViewModes);
	const isDrawerMode = useIsDrawerMode();
	const hidePrinterIcon = engagement.engagementStatusId === 33 && engagement.engagementSourceId === 10;

	if (
		documentTypeId === documentTypes.INDEPENDENCEFORMINDIVIDUAL ||
		documentTypeId === documentTypes.ACCOUNT_CONCLUSION ||
		(documentTypeId === documentTypes.PROFILEV2 && engagement && engagement.isProfileComplete === false)
	) {
		viewTypeOptions = viewTypeOptions && viewTypeOptions.filter((d) => d !== ViewModes.Details);
	}

	if (
		(documentTypeId === documentTypes.INDEPENDENCEFORMINDIVIDUAL && !showChangesOption) ||
		userPreferences.permissions?.hasIndependenceOnlyRole
	) {
		// Show Question and response for independence form only role users.
		viewTypeOptions = viewTypeOptions.filter((vt) => vt === ViewModes.Form);
	}
	const handleMoreMenuToggle = () => {
		setIsOpenMoreMenu(!isOpenMoreMenu);
	};
	const setClickOutside = () => {
		setIsOpenMoreMenu(false);
	};

	// Opens the form's print view for a given snapshot or the current version
	const openFormPrintView = () => {
		const _snapshotId = -1,
			snapshotUser = `${userPreferences.firstName} ${userPreferences.lastName}`;

		let formPrintUrl = `/canvasform/print?engagementid=${
			engagement.engagementId
		}&documentid=${documentId}&snapshotid=${_snapshotId}&snapshotuser=${encodeURIComponent(
			snapshotUser
		)}&isAutomatedPrint=true`;

		window.open(formPrintUrl);
	};
	const onBackClick = () => {
		window.location.href = env.getReturnUrl();
	};
	const inCompleteOptionLabel = ({label}) => {
		return (
			<section title={label} className="selectText">
				{label}
			</section>
		);
	};

	useEffect(() => {
		if (validations && validations.length > 0) {
			let inconsistentFormsCount = 0;
			validations.map((validation) => {
				if (validation.validationTypeId === validationTypes.IndependenceTemplateDifferentFromIndividual) {
					inconsistentFormsCount += validation.validationCount;
				}
			});

			setInconsistentFormsCount(inconsistentFormsCount);
		}
	}, [validations]);

	return (
		<section key="leftNavSearch" className="canvasFormLeftNavSearch">
			<section key="leftNavContainer" className="canvasFormLeftNavContainer">
				<section key="back" className="canvasFormBackContainer">
					{!isDrawerMode && !userPreferences.isGuestUser && env.getReturnUrl() && env.getReturnUrl().length > 0 && (
						<span className="canvasFormBack" onClick={onBackClick}>
							<EllipseControl content={labels.back} tooltip={labels.back} displayId={''} noOfLines={1} />
						</span>
					)}
					{hasContentUpdate === true && engagement && engagement.isProfileComplete !== false && (
						<span key="contentUpdate" className="contentUpdateAvailable" title={labels.contentUpdateAvailableTooltip}>
							<a
								href={
									env.getURL('hercules_web') +
									`/contentupdates/forms?engagementid=${engagement.engagementId}&searchstring=${encodeURI(
										document.documentName
									)}`
								}
								target="_blank"
							>
								<Icon src={IconoirRefreshDouble} />
								<EllipseControl
									content={labels.updateAvailable}
									tooltip={labels.contentUpdateAvailableTooltip}
									displayId={''}
									noOfLines={1}
								/>
							</a>
						</span>
					)}
				</section>
				<section key="formName" className="canvasFormName">
					{documentTypeId === documentTypes.INDEPENDENCEFORMINDIVIDUAL ? (
						<>
							{independenceInfo?.name === ' ' ? (
								<>
									{' '}
									{showDocName && (
										<span className="canvasFormDocName">
											<EllipseControl
												content={labels.undefined}
												tooltip={labels.undefined}
												displayId={''}
												noOfLines={1}
											/>
										</span>
									)}
								</>
							) : (
								<>
									{' '}
									{showDocName && (
										<span className="canvasFormDocName">
											<EllipseControl
												content={independenceInfo?.name}
												tooltip={independenceInfo?.name}
												displayId={''}
												noOfLines={1}
											/>
										</span>
									)}
								</>
							)}
						</>
					) : (
						<>
							{documentTypeId === documentTypes.ACCOUNT_CONCLUSION ? (
								<>
									{showDocName && (
										<span className="canvasFormDocName">
											<EllipseControl content={accountName} tooltip={accountName} displayId={''} noOfLines={1} />
										</span>
									)}
								</>
							) : (
								<>
									{showDocName && (
										<span className="canvasFormDocName">
											<EllipseControl content={formName} tooltip={formName} displayId={''} noOfLines={2} />
										</span>
									)}
								</>
							)}
						</>
					)}
					{userPreferences.isGuestUser && documentTypeId !== documentTypes.PROFILEV2 && (
						<section className="canvasFormLeftNavMoreMenu">
							<Dropdown
								open={isOpenMoreMenu}
								handleClickOutside={setClickOutside}
								trigger={
									<IconButton
										type="button"
										title={labels.moreMenu}
										onClick={handleMoreMenuToggle}
										ariaExpanded={isOpenMoreMenu}
										ariaLabel="dropdown trigger 1"
										iconSource={IconoirCustomMoreVerticalAlt}
									/>
								}
								children={
									filteredMoreMenuItems &&
									Array.isArray(filteredMoreMenuItems) &&
									filteredMoreMenuItems.map((item) => {
										return (
											<DropdownItem
												key={item.label}
												onClick={() => {
													if (item.closeMenuOnClick) {
														setIsExpanded(false);
													}
													item.onClick();
												}}
												children={item.label}
											/>
										);
									})
								}
							/>
						</section>
					)}
					<section
						className="canvasFormLeftNavMenuLink"
						onClick={onExpandCollapseClick}
						title={!isExpanded ? labels.expand : labels.collapse}
					>
						{/* <SVGICONS
							styleName="medium"
							name={isExpanded ? 'chevron-left' : 'chevron-right'}
							hoverText={!isExpanded ? labels.expand : labels.collapse}
						/> */}
						<Icon
							src={isExpanded ? IconoirNavArrowLeft : IconoirNavArrowRight}
							title={!isExpanded ? labels.expand : labels.collapse}
						/>
					</section>
				</section>
			</section>
			{documentTypeId === documentTypes.INDEPENDENCEFORMINDIVIDUAL ||
			documentTypeId === documentTypes.INDEPENDENCEFORMTEMPLATE ? (
				<section
					key="leftNavIndependence"
					className="canvasFormLeftNavControls canvasFormLeftNavControlsBlock whiteBottomBorder"
				>
					{validations && validations.length > 0 && (
						<section className="validationControls">
							{document && (
								<ValidationControl
									documentId={documentId}
									incompleteResponseCount={incompleteValidations || 0}
									unresolvedCommentCount={
										loadStorage('validationsFilter') !== validationFilter.INCOMPLETE ? unresolvedValidations : 0
									}
									changesNotSubmittedCount={
										validations &&
										validations.length > 0 &&
										validations.some(
											(t) =>
												t.validationTypeId === validationTypes.ProfileV2ChangeNotSubmitted ||
												t.validationTypeId === validationTypes.IndependenceChangeNotSubmitted
										)
											? 1
											: 0
									}
									itFlowValidationCount={0}
									inconsistentFormsCount={inconsistentFormsCount}
									darkBg
									clearComments={clearComments}
									entityUId={document.id}
									entityId={entities.Document}
								/>
							)}
						</section>
					)}
					<section className="independeStatus">
						<span className="statusLabel">{labels.status}</span>
						<span className="statusDescription">{setStatusLabel(independenceInfo?.independenceStatusId)}</span>
						<span className="modififedStatusText">
							{independenceInfo?.statusLastModifiedBy && (
								<span className="modifiedBy">{labels.byOn.replace('{0}', independenceInfo?.statusLastModifiedBy)}</span>
							)}
							{independenceInfo?.statusLastModifiedBy && independenceInfo?.modifyDate && (
								<span className="independenceModifyDate">
									<EllipsesMoment
										id="independenceModifyDate"
										useFormat
										userPreferences={userPreferences}
										date={independenceInfo?.modifyDate}
										useLocal={false}
									/>
								</span>
							)}
						</span>
						{independenceInfo?.comments && independenceInfo?.comments.length > 0 && (
							<>
								<span className="reasonLabel">{labels.reason}</span>
								<span className="reasonDescription">
									<EllipseControl
										content={independenceInfo?.comments}
										tooltip={independenceInfo?.comments}
										displayId={''}
										noOfLines={1}
									/>
								</span>
							</>
						)}
					</section>
				</section>
			) : (
				<section key="leftNavControls" className="canvasFormLeftNavControls whiteBottomBorder">
					{!userPreferences.isGuestUser && documentTypeId !== documentTypes.INDEPENDENCEFORMTEMPLATE && (
						<section key="controls" className="canvasFormControls">
							<section key="signOffs" className={`signOffControls ${!isExpanded ? 'hide' : ''}`}>
								{/*Need to disable signoff control until signOffs and document are retrieved from api*/}
								{document && document.id !== undefined && engagement && engagement.isProfileComplete !== false && (
									<SignOffs
										userDateFormat={userPreferences.dateFormat}
										engagementId={engagement.engagementId}
										document={document}
										docTypeId={documentTypeId}
										setDocument={setDocument}
										onSignOffAdded={onSignOffAdded}
										onSignOffRemoved={onSignOffRemoved}
										createSnapshotOnSignOff
									/>
								)}
							</section>
							<>
								{isExpanded && engagement && engagement.isProfileComplete !== false && (
									<NotesCount
										engagementId={engagement.engagementId}
										document={document}
										documentId={documentId}
										entityUId={document && document.id}
										isCustomIcon
									/>
								)}
							</>
						</section>
					)}
					{page === ViewModes.Form &&
						((signOffs && signOffs.allIds.length > 0) ||
							documentTypeId === documentTypes.INDEPENDENCEFORMINDIVIDUAL ||
							documentTypeId === documentTypes.PROFILEV2) && (
							<section key="validations" className="validationControls">
								<ValidationControl
									incompleteResponseCount={incompleteValidations || 0}
									unresolvedCommentCount={
										loadStorage('validationsFilter') !== validationFilter.INCOMPLETE ? unresolvedValidations : 0
									}
									changesNotSubmittedCount={
										validations &&
										validations.length > 0 &&
										validations.some(
											(t) =>
												t.validationTypeId === validationTypes.ProfileV2ChangeNotSubmitted ||
												t.validationTypeId === validationTypes.IndependenceChangeNotSubmitted
										)
											? 1
											: 0
									}
									itFlowValidationCount={itFlowValidationCount}
									inconsistentFormsCount={inconsistentFormsCount}
									darkBg
									clearComments={clearComments}
									entityUId={document && document.id}
									entityId={entities.Document}
									itFlowFormValidations={itFlowFormValidations}
								/>
							</section>
						)}
					{!userPreferences.isGuestUser &&
						documentTypeId !== documentTypes.PROFILEV2 &&
						documentTypeId !== documentTypes.INDEPENDENCEFORMTEMPLATE && (
							<section key="moreMenu" className={`canvasFormLeftNavMoreMenu ${!isExpanded ? 'hide' : ''}`}>
								<Dropdown
									open={isOpenMoreMenu}
									handleClickOutside={setClickOutside}
									trigger={
										<IconButton
											type="button"
											title={labels.moreMenu}
											onClick={handleMoreMenuToggle}
											ariaExpanded={isOpenMoreMenu}
											ariaLabel="dropdown trigger 1"
											iconSource={IconoirCustomMoreVerticalAlt}
										/>
									}
									children={
										filteredMoreMenuItems &&
										Array.isArray(filteredMoreMenuItems) &&
										filteredMoreMenuItems.map((item) => {
											return (
												<DropdownItem
													key={item.label}
													onClick={() => {
														if (item.closeMenuOnClick) {
															setIsExpanded(false);
														}
														item.onClick();
													}}
													children={item.label}
												/>
											);
										})
									}
								/>
							</section>
						)}
				</section>
			)}
			{/* Search textbox */}
			{page === ViewModes.Form && (
				<>
					<section className="canvasFormLeftSearch">
						<Search
							styleName="railSearchWrapper"
							onChange={onSearchChange}
							darkBg
							placeholder={labels.leftNavSearchPlaceholder}
							searchHoverText={labels.leftNavSearchPlaceholder}
							clearHoverText={labels.clearHoverText}
							value={searchValue}
						/>
					</section>
				</>
			)}
			{/* Validations filter dropdown */}
			<section
				key="leftNavBottom"
				className="canvasFormLeftNavControls whiteBottomBorder canvasFormLeftNavControlsFilter"
			>
				{isExpanded && (
					<>
						{/* <section className="canvasFormLeftNavSelectTxt">
							<EllipseControl content={labels.show} tooltip={labels.show} displayId={''} noOfLines={1} />
						</section> */}
						<section className="canvasFormLeftNavSelect">
							<ReactSelect
								formLabel={labels.show}
								id="inComplete"
								className="inCompleteSelect"
								formatOptionLabel={inCompleteOptionLabel}
								defaultValue={[validationFilterOption]}
								options={currentResource.railFilterValidations}
								onChange={validationFilterChange}
								value={[validationFilterOption]}
								noOptionsMessage={() => labels.noResultsFound}
								theme={getTheme()}
							/>
						</section>
						{/* Print icon */}
						{viewTypeOptions?.length > 0 && !hidePrinterIcon && (
							<section
								className={`canvasFormLeftNavForms canvasFormLeftNavPrint
											${viewTypeOptions.length === 2 ? 'canvasFormViewMenu' : ''}`}
							>
								<section className="IconPrint" onClick={() => openFormPrintView()} title={labels.print}>
									<Icon src={IconoirPrintingPage} title={labels.print} />
								</section>
							</section>
						)}
					</>
				)}
			</section>
			<section
				className={`${
					isExpanded
						? `canvasFormLeftNavForms whiteBottomBorder canvasFormLeftNavFormsMotifDropdown ${
								viewTypeOptions.length === 2 ? ' canvasFormViewMenu' : ''
						  }`
						: 'canvasFormLeftNavControls whiteBottomBorder canvasFormLeftNavControlsViewTypeSelect'
				}`}
			>
				<CanvasFormViewType
					viewTypeOptions={viewTypeOptions}
					page={page}
					setPage={setPage}
					isExpanded={isExpanded}
					onFormViewTypeClick={onFormViewLabelClick}
				/>
			</section>
		</section>
	);
}
